// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ping circle[data-v-20d1dccb]{animation:ping-20d1dccb 1s ease-out infinite;transform-origin:center}@keyframes ping-20d1dccb{0%{transform:scale(1);opacity:1}50%{transform:scale(2);opacity:0}to{transform:scale(1);opacity:1}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
